var _a;
import { MediaType } from '@wix/wixstores-client-core/dist/src/types';
export var translationPath = function (baseUrl, locale) { return baseUrl + "assets/locale/productPage/productPage_" + locale + ".json"; };
export var widgetId = '13a94f09-2766-3c40-4a32-8edb5acdd8bc';
export var PRODUCT_PAGE_DSN = 'https://5605bf8f38c54260af44e1d7bc2450bd@sentry.io/1362236';
export var PRODUCT_PAGE_APP_NAME = 'wixstores-product-page';
export var defaultFontSize = 16;
export var TabsDirection;
(function (TabsDirection) {
    TabsDirection["start"] = "left";
    TabsDirection["end"] = "right";
})(TabsDirection || (TabsDirection = {}));
export var InfoSectionLayoutId;
(function (InfoSectionLayoutId) {
    InfoSectionLayoutId[InfoSectionLayoutId["Collapse"] = 1] = "Collapse";
    InfoSectionLayoutId[InfoSectionLayoutId["Stacked"] = 3] = "Stacked";
    InfoSectionLayoutId[InfoSectionLayoutId["Tabs"] = 2] = "Tabs";
    InfoSectionLayoutId[InfoSectionLayoutId["Columns"] = 4] = "Columns";
})(InfoSectionLayoutId || (InfoSectionLayoutId = {}));
export var LayoutMap = (_a = {},
    _a[1 /* Classic */] = "classic" /* Classic */,
    _a[2 /* QuickView */] = "quickView" /* QuickView */,
    _a[3 /* Mobile */] = "mobile" /* Mobile */,
    _a[4 /* Sleek */] = "sleek" /* Sleek */,
    _a[5 /* Stunning */] = "stunning" /* Stunning */,
    _a[6 /* Spotlight */] = "spotlight" /* Spotlight */,
    _a[7 /* Simple */] = "simple" /* Simple */,
    _a);
export var keyboardEvents = {
    ENTER: { keyCode: 13, charCode: 13 },
    SPACEBAR: { keyCode: 32, charCode: 13 },
    ARROW_UP: { keyCode: 38, charCode: 38 },
    ARROW_DOWN: { keyCode: 40, charCode: 40 },
    ARROW_RIGHT: { keyCode: 39, charCode: 39 },
    ARROW_LEFT: { keyCode: 37, charCode: 37 },
};
export var ImageRatioList = [
    {
        sdkId: 0,
        title: '3:2',
        ratio: { width: 3, height: 2 },
    },
    {
        sdkId: 1,
        title: '4:3',
        ratio: { width: 4, height: 3 },
    },
    {
        sdkId: 2,
        title: '1:1',
        ratio: { width: 1, height: 1 },
    },
    {
        sdkId: 3,
        title: '3:4',
        ratio: { width: 3, height: 4 },
    },
    {
        sdkId: 4,
        title: '2:3',
        ratio: { width: 2, height: 3 },
    },
];
export var defaultProductMediaImage = {
    url: 'eaa00d_b02f06cef98b454c8b56a1dcebdacee4.jpg',
    mediaType: MediaType.PHOTO,
    title: '',
    index: 1,
    width: 800,
    height: 800,
};
export var defaultQuantity = 1;
export var trackEventMetaData = Object.freeze({
    origin: 'Stores',
    category: 'All Products',
});
export var GRAPHQL_SOURCE = 'WixStoresWebClient';
//# sourceMappingURL=constants.js.map